<template>
  <el-dialog
    class="dialog-leave-apply"
    :title="renderData.name"
    :visible.sync="dialogShow"
    :before-close="handleBeforeClose"
    width="630px"
  >
    <div class="content">
      <el-form
        class="g-form-grid mt-10"
        @keyup.enter.native="submitForm('form')"
        :model="form"
        :rules="rules"
        ref="form"
        :label-width="renderData.fieldsLabelWidth || '110px'"
      >
        <!-- 非附件 -->
        <div v-for="(item, index) in renderData.fields" :key="index">
          <cmpFormItem
            v-if="item.type !== 'file' && item.type !== 'date-list'"
            :itemData="item"
            :configOptions="configOptions"
            :form="form"
            :remoteFileList="remoteFileList"
            :isDisable="item.isDisable"
            @changeTimeMul="changeTimeMul"
            @changeHolidayType="changeHolidayType"
            @calcTime="calcTime"
            @calcTimeNoon="calcTimeNoon"
            @fujian="fujian"
            @callFunDisable="callFunDisable"
            @callFunOther="callFunOther"
            @eventChecker="eventChecker"
          ></cmpFormItem>

          <!-- 可多选的日历列表 -->
          <div class="date-list-box" style="display:flex;flex-wrap: wrap;" v-if="item.type === 'date-list'">
            <div class="date-item" v-for="(it, i) in item.arr"
            :key="'date-' + i" style="position:relative;">
              <cmpFormItem
                :itemData="it"
                :configOptions="configOptions"
                :form="form"
                :isDisable="it.isDisable"
                @calcTime="calcTime"
              ></cmpFormItem>
              <span class="close-box ml-5" @click="deleDate(item.arr, i)"><i class="el-icon-close"></i></span>
            </div>
            <span class="date-add m-btn" @click="addDate(item.arr)">添加</span>
          </div>
        </div>

        <!-- 明细列表 -->
        <cmpFormList
          ref="cmpFormList"
          :detailObj="renderData.detail"
          @setCalc="setCalc"
          v-if="renderData.detail && renderData.detail.length"
        ></cmpFormList>

        <!-- 附件 -->
        <div
          v-for="(item, index) in renderData.fields"
          :key="'fujian-' + index"
        >
          <cmpFormItem
            v-if="item.type === 'file'"
            :itemData="item"
            :configOptions="configOptions"
            :form="form"
            :remoteFileList="remoteFileList"
            @changeTimeMul="changeTimeMul"
            @changeHolidayType="changeHolidayType"
            @calcTime="calcTime"
            @calcTimeNoon="calcTimeNoon"
            @fujian="fujian"
            @eventChecker="eventChecker"
          ></cmpFormItem>
        </div>

        <!-- 版本2 -->
        <div class="time-line-wrap">
          <el-timeline>
            <el-timeline-item v-for="(item, index) in approval" :key="index">
              <h3 class="mb-10">
                {{ item.type === 1 ? '审批人' : '抄送人' }}
                <el-tag
                  size="mini"
                  v-if="
                    item.examineMode === 1 &&
                      item.nodeUserList &&
                      item.nodeUserList.length > 1
                  "
                  >或签</el-tag
                >
                <el-tag size="mini" v-if="item.examineMode === 2">会签</el-tag>
              </h3>
              <div
                class="timeline-box"
                v-for="(it, i) in item.nodeUserList"
                :key="i"
              >
                <img
                  class="g-pic mini mr-10"
                  :src="it.userImage || ''"
                  alt
                  :onerror="defaultHeadImg"
                />
                <div class="timeline-content">
                  <div>
                    <span class="m-des mr-10">{{ it.name }}</span>
                    <!-- 0 发起申请 1 审批中 2 已同意 6 审批通过 3 审批拒绝 4 已撤销 -->
                    <!-- <span
                      :class="{'m-warning': it.statusCode==='1', 'm-info': it.statusCode==='2', 'm-danger': it.statusCode==='3', 'm-primary': it.statusCode==='6'}"
                    >{{it.status}}</span>-->
                    <!-- <span class="m-assist fr">{{it.date}}</span> -->
                  </div>
                  <p class="m-assist">{{ it.comment }}</p>
                  <!-- <p class="m-assist" style="min-height:24px;">{{item.comment}}</p> -->
                </div>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>

        <!-- 版本1 -->
        <!-- 审批人、抄送人 -->
        <!-- <div class="mt-20">
          <el-form-item label="审批人：" required>
            <div class="approve-list-person">
              <div class="person-box" v-for="item in approverList" :key="item.userId">
                <span class="line ml-10 mr-10"></span>
                <img class="g-pic mini" :src="item.userImage||''" alt :onerror="defaultHeadImg">
                <span class="m-des ml-10">{{item.name}}</span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="抄送人：">
            <div class="approve-list-person">
              <div class="person-box mr-20" v-for="(item, index) in copytoList" :key="item.userId">
                <img class="g-pic mini" :src="item.userImage||''" alt :onerror="defaultHeadImg">
                <span class="m-des ml-10">{{item.name}}</span>

                <i class="el-icon-close" v-if="item.canDele" @click="dele(item, index)"></i>
              </div>

              <el-popover
                class="pop-wrap"
                placement="top-start"
                trigger="click"
                v-model="showPopover"
                v-if="!dataAll.permission"
              >
                <cmp-leader-list
                  ref="cmpLeaderList"
                  :isSinglePro="false"
                  :businessType="`copyStart`"
                  :callFun="handleChooseAdd"
                ></cmp-leader-list>

                <span class="operate g-pointer" slot="reference" @click="showLeaderList">
                  <svg-icon icon-class="add-dash" style="font-size: 26px;"></svg-icon>
                </span>
              </el-popover>
            </div>
          </el-form-item>

          <el-form-item>
            <p class="m-tit" style="line-height:20px;">{{dataAll.notice}}</p>
          </el-form-item>
        </div>-->
      </el-form>
    </div>

    <div class="dialog-footer tr">
      <el-button
        type="primary"
        :loading="loadingSave"
        @click="submitForm('form')"
        >提交</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import cmpFormItem from '@cmp/form/item'
import cmpFormList from '@cmp/form/list'
import cmpLeaderList from '@cmp/leader-list'
import moment from 'moment'
export default {
  components: { cmpFormItem, cmpFormList, cmpLeaderList },
  data() {
    return {
      loadingSave: false,
      showLeaderPopover: false,
      defaultHeadImg: this.$store.state.app.defaultHeadImg,
      dialogShow: false,
      showPopover: false,
      configOptions: {
        startTime: {},
        endTime: {}
      },
      // 默认上下班时间
      configTime: {
        workTimeStart: '08:30', // 上班开始时间
        workTimeEnd: '17:30', // 上班结束时间
        overtimeStart: '08:00', // 加班开始时间
        overtimeEnd: '18:00' // 加班结束时间
      },
      configId: '', // 表单配置id
      renderData: '', // 表单data
      form: {
        // startTime: '',
        // endTime: '',
        snoon: '1',
        enoon: '1'
      },
      remoteFileList: [],
      dataAll: {},
      approval: [], // 审批节点集合
      approverList: [], //审批人列表
      copytoList: [], //抄送人列表
      rules: {}
    }
  },
  methods: {
    init(id) {
      this.dialogShow = true
      this.configId = id

      // this.resetForm()
      this.getDataList()
    },
    getDataList(type, params) {
      // 1请假类型改变 2时长改变
      this.$http
        .post('/workflowInst/form', {
        // .get(`../${process.env.BASE_URL}test/form-jbsq.json`, {
        // .get(`../${process.env.BASE_URL}test/form-qjsq.json`, {
        // .get(`../${process.env.BASE_URL}test/form.json`, {
        // .get(`../${process.env.BASE_URL}test/form.1.json`, {
          configId: this.configId,
          ...params
        })
        .then(res => {
          if (res.success) {
            let data = res.result

            data.form.fields.forEach(item => {
              if(item.labelWidth) {
                item.labelWidth = item.labelWidth + 'px'
              }
            })
            data.form.detail.forEach(item => {
              if(item.labelWidth) {
                item.labelWidth = item.labelWidth + 'px'
              }
            })
            // data.form.showType = '1'  // 1默认时间段 2点选 3自动计算结束时长
            // data.form.fields.splice(2, 0, {
            //   name: 'startTimeArr',
            //   type: 'date-list',
            //   arr: [
            //     {
            //       "name": "startTime_1",
            //       "ralationship": 'durationDay',
            //       "rules": [
            //         {
            //         "trigger": "blur",
            //         "message": "必填",
            //         "required": true
            //         }
            //       ],
            //       "label": "请假时间",
            //       "placeholder": "请选择",
            //       "type": "date"
            //     }
            //   ]
            // })
            // console.log(111, data.form)

            if(type === '3') {
              // 金额改变、只改变审批人
              this.approval = data.approval
              return
            }

            this.dataAll = data
            this.renderData = data.form
            this.form.key = data.form.key

            this.approval = data.approval


            // 加班申请 只能从三天前开始选
            if(this.form.key === 'JBSQ') {
              let dateMin = moment().subtract(3, 'day').format('YYYY-MM-DD')
              this.configOptions.startTime = Object.assign(
                {},
                this.configOptions.startTime,
                {
                  disabledDate: time => {
                    return time.getTime() < moment(dateMin).valueOf()
                  }
                }
              )
              this.configOptions.endTime = Object.assign(
                {},
                this.configOptions.endTime,
                {
                  disabledDate: time => {
                    return time.getTime() < moment(dateMin).valueOf()
                  }
                }
              )
            } else {
              this.configOptions.startTime = {}
              this.configOptions.endTime = {}
            }

            // todo dele
            this.approverList = data.approverList
            this.copytoList = data.copytoList

            if (this.renderData.detail.length) {
              this.$nextTick(() => {
                this.$refs.cmpFormList.init()
              })
            }

            if (type === '1') {
              // 1 请假类型改变
              this.$nextTick(() => {
                // this.remoteFileList = []
                // this.form.key = this.form.key
                this.form.startTime = ''
                this.form.endTime = ''
                this.form.snoon = '1'
                this.form.enoon = '1'
                this.$refs['form'].clearValidate()
              })
            } else if (type === '2') {
              // 2 请假时长改变
              // this.form.key = this.form.key
              // this.form.key = this.form.key
              // this.form.key = this.form.key
              // this.form.key = this.form.key
              this.$refs['form'].clearValidate()
            } else {
              this.resetForm()
            }
            // 复选框的情况、多选下拉框
            this.renderData.fields.forEach(item => {
              if(item.type === 'checkbox' || item.multiple) {
                this.$nextTick(() => {
                  this.$set(this.form, item.name, [])
                })
              }
            })
            // todo详情中复选框的情况
            // this.renderData.detail.forEach(item => {
            //   if(item.type === 'checkbox') {
            //     this.$nextTick(() => {
            //       this.$set(this.form, item.name, [])
            //     })
            //   }
            // })

            // this.resetForm()
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 添加日历
    addDate(item) {
      console.log(item)
      let num = item.length + 1
      item.push({
        "name": "startTime_" + num,
        "ralationship": 'durationDay',
        "rules": [
          {
          "trigger": "blur",
          "message": "必填",
          "required": true
          }
        ],
        "label": "请假时间",
        // "label": "",
        // "labelWidth": "30px",
        "placeholder": "请选择",
        "type": "date"
      })
    },
    deleDate(item, index) {
      if(item.length > 1) {
        item.splice(index, 1)
      } else {
        this.$message.warning('至少保留一个请假时间')
      }
    },
    showLeaderList() {
      this.$refs.cmpLeaderList.showList(this.copytoList)
    },
    // 选择抄送人
    handleChooseAdd(item) {
      this.$set(item, 'canDele', true)
      this.copytoList.push(item)
      this.showPopover = false
    },
    // 设置总金额
    setCalc(name, total) {
      this.$set(this.form, name, total)

      // 金额改变、审批人改变
      this.getDataList('3', { holidayType: this.form.holidayType, totalAmount: this.form.totalAmount })
    },
    // 请假时长输入框改变
    eventChecker() {
      // 审批人改变
      this.getDataList('3', { ...this.form })
    },
    // 请假多选框 修改
    changeTimeMul() {
      console.log(this.form)
      // this.$set(this.form, 'durationDay', 3)
      // this.eventChangeTimeQJ()
    },
    // 请假申请类型改变
    changeHolidayType() {
      this.$nextTick(() => {
        this.$set(this.form, 'startTime', '')
        this.$set(this.form, 'endTime', '')
      })

      this.getDataList('1', { holidayType: this.form.holidayType })
    },
    // 请假时长修改重新拉取数据
    eventChangeTimeQJ() {
      if (this.form.key !== 'QJSQ') return

      this.getDataList('2', {...this.form})
      // if (this.form.holidayType === '0' || this.form.holidayType === '3') {
      //   this.getDataList('2', {
      //     holidayType: this.form.holidayType,
      //     startTime: this.form.startTime,
      //     endTime: this.form.endTime,
      //     snoon: this.form.snoon,
      //     enoon: this.form.enoon,
      //     durationDay: this.form.durationDay
      //   })
      // } else {
      //   this.getDataList('2', {
      //     holidayType: this.form.holidayType,
      //     startTime: this.form.startTime,
      //     endTime: this.form.endTime,
      //     durationHour: this.form.durationHour
      //   })
      // }
    },
    fujian(fileStr) {
      this.form.attachmentIds = fileStr
    },
    // 设为禁用或启用
    callFunDisable(aboutName, name) {
      this.renderData.fields.forEach(item => {
        if(item.name === aboutName) {
          this.$set(item, 'isDisable', this.form[name].length?true:false)
        }
      })
    },
    // 选择其他时出现文本框 将isHide改为false
    callFunOther(aboutName, name, val) {
      console.log(2334)
      this.renderData.fields.forEach(item => {
        if(item.name === aboutName) {
          this.$set(item, 'isHide', val)
        }
      })
    },
    // 删除抄送人
    dele(item, index) {
      this.copytoList.splice(index, 1)
    },
    // 计算上午、下午
    calcTimeNoon(aboutName, name) {
      this.disableTime(name)

      if (!this.form.startTime || !this.form.endTime) return
      let totalDays = moment(this.form.endTime).diff(
        moment(this.form.startTime),
        'days',
        true
      )
      if (this.form.snoon === '1' && this.form.enoon === '2') {
        // 上午-下午
        totalDays += 1
      } else if (this.form.snoon === this.form.enoon) {
        totalDays += 0.5
      } else {
        if (this.form.startTime === this.form.endTime) {
          this.$message.warning('结束时间需大于开始时间')
          return
        }
        // 下午-上午
        // totalDays += 1
      }
      this.$set(this.form, aboutName, totalDays)

      this.eventChangeTimeQJ()
    },
    // 计算时长
    calcTime(aboutName, name) {
      if(this.form.key === 'QJSQ' && name.includes('startTime_')) {
        // 请假申请中的点选
        this.calcTimeMul(aboutName, name)
        return
      }

      if (!this.disableTime(name)) return
      if (this.form.key === 'QJSQ') {
        this.calcTimeQJSQ(aboutName, name)

        this.eventChangeTimeQJ()
      } else if (this.form.key === 'JBSQ') {
        this.calcTimeJBSQ(aboutName, name)
      } else if (this.form.key === 'WCSQ') {
        this.calcTimeWCSQ(aboutName, name)
      } else if (this.form.key === 'CXSQ') {
        // 串休申请
        this.calcTimeQJSQ(aboutName, name)
        this.getDataList('3', {...this.form})
      }
    },
    // 计算外出申请
    calcTimeWCSQ(aboutName) {
      if (!this.form.startTime || !this.form.endTime) return

      let totalHours = moment(this.form.endTime).diff(
        this.form.startTime,
        'hours',
        true
      )

      totalHours = Math.round(totalHours * 100) / 100

      this.$set(this.form, aboutName, totalHours)
    },
    // 请假申请中的点选
    calcTimeMul(aboutName, name) {
      if(!this.form.holidayType) {
        this.$message.warning('请选择请假类别')
        return
      }
      // 日期可多选 start
      let timeArr = []
      for(let key in this.form) {
        if(key.includes('startTime_')) {
          timeArr.push(this.form[key])
        }
      }
      // console.log(timeArr)
      this.form.startTimeArr = timeArr
      // 日期可多选 end

      this.$http
        .get('/workflowForm/duration', {
          startTimeArr: timeArr,
          key: this.form.key,
          holidayType: this.form.holidayType
        })
        .then(res => {
          if (res.success) {
            this.$set(this.form, aboutName, res.result)

            // 自动计算结束时长
            // if(this.form.showType === '3') {
            //   this.$set(this.form, 'endTime', '2022-08-30')
            // }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 计算请假申请
    calcTimeQJSQ(aboutName) {
      if (!this.form.startTime || !this.form.endTime) return

      // 选中当天开始、结束日期
      let todayChooseStart = moment(this.form.startTime).format('YYYY-MM-DD HH:mm')
      let todayChooseEnd = moment(this.form.endTime).format('YYYY-MM-DD HH:mm')

      if(this.form.key === 'QJSQ' && !this.form.holidayType) {
        this.$message.warning('请选择请假类别')
        return
      }
      this.$http
        .get('/workflowForm/duration', {
          startTime: todayChooseStart,
          endTime: todayChooseEnd,
          key: this.form.key,
          holidayType: this.form.holidayType
        })
        .then(res => {
          if (res.success) {
            this.$set(this.form, aboutName, res.result)
          } else {
            this.$message.error(res.message)
          }
        })

      // // 选中当天开始、结束日期
      // let todayChooseStart = moment(this.form.startTime).format('YYYY-MM-DD')
      // let todayChooseEnd = moment(this.form.endTime).format('YYYY-MM-DD')

      // // 获取总间隔天数
      // let totalDays = moment(todayChooseEnd).diff(todayChooseStart, 'days')
      // let subFirst = this.getSubHours(todayChooseStart, this.form.startTime) // 开始时间需减去的小时数
      // let addEnd = this.getSubHours(todayChooseEnd, this.form.endTime) // 结束时间需加上的小时数

      // let totalHours = totalDays * 9 - subFirst + addEnd
      // totalHours = Math.round(totalHours * 100) / 100
      // this.$set(this.form, aboutName, totalHours)
    },
    // 计算加班申请
    calcTimeJBSQ(aboutName) {
      this.calcTimeQJSQ(aboutName)

      // // 一整天加班时长
      // let oneDayOvertime =
      //   24 -
      //   moment(todayChooseStart + ' 18:30').diff(
      //     todayChooseStart + ' 08:30',
      //     'hours',
      //     true
      //   ) // 14小时

      // // 获取总间隔天数
      // let totalDays = moment(todayChooseEnd).diff(todayChooseStart, 'days')
      // let subFirst = this.getSubHoursOver(
      //   todayChooseStart,
      //   this.form.startTime,
      //   oneDayOvertime
      // ) // 开始时间需减去的小时数
      // let addEnd = this.getSubHoursOver(
      //   todayChooseEnd,
      //   this.form.endTime,
      //   oneDayOvertime
      // ) // 结束时间需加上的小时数

      // let totalHours = totalDays * oneDayOvertime - subFirst + addEnd
      // totalHours = Math.round(totalHours * 100) / 100
      // // this.$set(this.form, aboutName, totalHours)

      // // let totalHours = moment(this.form.endTime).diff(
      // //   moment(this.form.startTime),
      // //   'hours',
      // //   true
      // // )
      // // let days = Math.floor(totalHours / 24) // 天数
      // // let arrHour = (totalHours % 24).toString().split('.')
      // let arrHour = totalHours.toString().split('.')
      // // 剩余小时数 不足一小时大于半小时计 0.5，不足半小时不计入
      // let hours =
      //   Number(arrHour[0]) + (Number('0.' + arrHour[1]) >= 0.5 ? 0.5 : 0)
      // this.$set(this.form, aboutName, hours)
      // // console.log('时长', days * 8 + hours)
      // // this.$set(this.form, aboutName, days * 8 + hours)
    },
    // 请假
    getSubHours(chooseDay, time) {
      let subHours = 0
      if (
        moment(time).isBefore(
          chooseDay + ' ' + this.configTime.workTimeStart
        ) ||
        moment(time).isSame(chooseDay + ' ' + this.configTime.workTimeStart)
      ) {
        subHours = 0
      } else if (
        moment(time).isBetween(
          chooseDay + ' ' + this.configTime.workTimeStart,
          chooseDay + ' ' + this.configTime.workTimeEnd
        )
      ) {
        subHours =
          9 -
          moment(chooseDay + ' ' + this.configTime.workTimeEnd).diff(
            time,
            'hours',
            true
          )
      } else {
        subHours = 9
      }
      subHours = Math.round(subHours * 100) / 100
      return subHours
    },
    // 加班
    getSubHoursOver(chooseDay, time, oneDayOvertime) {
      let subHours = 0
      if (
        moment(time).isBefore(
          chooseDay + ' ' + this.configTime.overtimeStart
        ) ||
        moment(time).isSame(chooseDay + ' ' + this.configTime.overtimeStart)
      ) {
        subHours = moment(time).diff(chooseDay + ' 00:00', 'hours', true)
      } else if (
        moment(time).isBetween(
          chooseDay + ' ' + this.configTime.overtimeStart,
          chooseDay + ' ' + this.configTime.overtimeEnd
        )
      ) {
        subHours = moment(chooseDay + ' ' + this.configTime.overtimeStart).diff(
          chooseDay + ' 00:00',
          'hours',
          true
        )
      } else {
        subHours =
          oneDayOvertime -
          (24 - moment(time).diff(chooseDay + ' 00:00', 'hours', true))
      }
      subHours = Math.round(subHours * 100) / 100
      return subHours
    },
    // 时间约束
    disableTime(name) {
      let isValid = true
      if (name === 'startTime') {
        if (moment(this.form.endTime).isBefore(this.form.startTime)) {
          this.form.endTime = ''
          isValid = false
        }
        // moment(this.form.startTime).isBefore(this.form.endTime)
        // this.configOptions.endTime = Object.assign(
        //   {},
        //   this.configOptions.endTime,
        //   {
        //     disabledDate: time => {
        //       return time.getTime() < moment(this.form.startTime).valueOf()
        //     }
        //   }
        // )
      }
      if (name === 'endTime') {
        if (moment(this.form.endTime).isBefore(this.form.startTime)) {
          this.form.startTime = ''
          isValid = false
        }
        // this.configOptions.startTime = Object.assign(
        //   {},
        //   this.configOptions.startTime,
        //   {
        //     disabledDate: time => {
        //       return time.getTime() > moment(this.form.endTime).valueOf()
        //     }
        //   }
        // )
      }
      return isValid
    },
    submitForm(formName) {
      console.log('form', this.form)
      // console.log(this.$refs.cmpFormList.getFormList())

      // 请假申请
      if (this.form.key === 'QJSQ') {
        // 年假、调休假
        if (this.form.holidayType === '0' || this.form.holidayType === '3') {
          if (
            this.form.startTime === this.form.endTime &&
            this.form.snoon === '2' &&
            this.form.enoon === '1'
          ) {
            this.$message.warning('结束时间需大于开始时间')
            return
          }
        }
      }

      // let copyIds = []
      // this.copytoList.forEach(item => {
      //   if (item.canDele) {
      //     copyIds.push(item.userId)
      //   }
      // })

      this.$refs[formName].validate(valid => {
        // 校验明细列表
        if (
          this.renderData.detail.length &&
          !this.$refs.cmpFormList.isValidate()
        ) {
          return
        }

        // 校验上部表单
        if (valid) {
          this.loadingSave = true
          this.$http
            .post('/workflowInst/start', {
              configId: this.configId,
              // extcopyto: copyIds,
              extcopyto: [],
              data: {
                ...this.form,
                detail: this.renderData.detail.length
                  ? this.$refs.cmpFormList.getFormList()
                  : []
              }
            })
            .then(res => {
              this.loadingSave = false
              if (res.success) {
                this.$message.success('发起' + this.renderData.name + '成功')
                this.$store.dispatch('updataSiderbarCount')
                this.dialogShow = false
              } else {
                this.$message.error(res.message)
              }
            })
            .catch(() => {
              this.loadingSave = false
            })
        } else {
          return false
        }
      })
    },
    resetForm() {
      this.$nextTick(() => {
        this.remoteFileList = []
        this.form = {
          key: this.form.key,
          startTime: '',
          endTime: '',
          snoon: '1',
          enoon: '1',
        }
        this.$refs['form'].clearValidate()
        // this.$refs['form'].resetFields()
      })
    },
    handleBeforeClose(done) {
      this.resetForm()
      done()
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-leave-apply {
  .content {
    height: 700px;
    overflow-y: auto;
    padding-right: 10px;
  }

  .time-line-wrap {
    padding-top: 30px;
    border-bottom: solid 1px $border;
    .timeline-box {
      padding: 5px 0;
      display: flex;
      line-height: 24px;
      align-items: center;
      .timeline-content {
        flex: 1;
      }
    }
  }

  .approve-list-person {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .person-box {
      position: relative;
      display: flex;
      align-items: center;
      &:first-child {
        .line {
          display: none;
        }
      }
      .line {
        width: 20px;
        height: 1px;
        background: $primary;
      }
    }
  }

  .operate {
    .svg-icon {
      vertical-align: middle;
    }
  }

  .el-icon-close {
    position: absolute;
    right: -7px;
    top: 0;
    color: #fff;
    background-color: $color6;
    padding: 2px;
    border-radius: 100%;
    cursor: pointer;
    font-size: 12px;
  }

  .date-list-box {
    .date-item {
      margin-bottom: 20px;
    }
    .close-box {
      position: absolute;
      top: 0;
      right: 0;
      // .el-icon-close {
      //   right: -30px;
      //   top: 10px;
      // }
    }
    .date-add {
      margin: 10px 30px;
    }
    /deep/ .el-form-item {
      margin-bottom: 0;
    }
  }
}
</style>
